import { render, staticRenderFns } from "./task-new-page.html?vue&type=template&id=6f35b6b4&external"
import script from "./task-new-page.js?vue&type=script&lang=js&external"
export * from "./task-new-page.js?vue&type=script&lang=js&external"
import style0 from "./task-new-page.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports